module.exports = __webpack_public_path__ + "img/cgjz-5.096b05e9.jpg";